import { Component, inject } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';

export type ReportUploadSheetType = 'success' | 'error' | 'notReport';

export const REPORT_UPLOAD_SHEET_TYPE = {
  SUCCESS: 'success' as ReportUploadSheetType,
  ERROR: 'error' as ReportUploadSheetType,
  NOT_REPORT: 'notReport' as ReportUploadSheetType,
};

@Component({
  selector: 'report-upload-sheet',
  templateUrl: './report-upload-sheet.html',
  standalone: false,
})
export class ReportUploadSheetComponent {
  data: { type: ReportUploadSheetType } = inject(MAT_BOTTOM_SHEET_DATA);
  readonly SHEET_TYPE = REPORT_UPLOAD_SHEET_TYPE;
  private bottomSheetRef: MatBottomSheetRef = inject(MatBottomSheetRef);

  close(): void {
    this.bottomSheetRef.dismiss();
  }
}
